import React from "react";
import { Link } from "react-router-dom";
import "./HomeNavItem.scss";

type Props = {
  iconSrc: string;
  text: string;
  path: string;
  name: string;
  external?: boolean;
};

function HomeNavItem({ path, external, iconSrc, text, name }: Props) {
  return (
    <div className="home-nav-item">
      {(external && (
        <a href={path} target="_blank" rel="noopener noreferrer">
          <div className="circle">
            <img src={iconSrc} alt={`${name} icon`} className="icon" />
          </div>
          <div className="nav-text">{text}</div>
        </a>
      )) || (
        <Link to={path}>
          <div className="circle">
            <img src={iconSrc} alt={`${name} icon`} className="icon" />
          </div>
          <div className="nav-text">{text}</div>
        </Link>
      )}
    </div>
  );
}
export { HomeNavItem as default };
